var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox-group',{attrs:{"checked":_vm.value,"options":_vm.bladen,"stacked":""},on:{"input":_vm.changeBladen}})
}
var staticRenderFns = []

export { render, staticRenderFns }